
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"13.5","viewBox":"0 0 18 13.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 147243","d":"M15.75 0H2.25A2.266 2.266 0 000 2.25v9a2.266 2.266 0 002.25 2.25h13.5A2.266 2.266 0 0018 11.25v-9A2.266 2.266 0 0015.75 0zM2.25 1.125h13.5a1.111 1.111 0 011.125 1.125v1.266L10.02 8.648a1.688 1.688 0 01-2.039 0L1.126 3.515V2.25A1.111 1.111 0 012.25 1.125zM16.875 11.25a1.111 1.111 0 01-1.125 1.125H2.25a1.111 1.111 0 01-1.125-1.125V4.922l6.187 4.641A2.71 2.71 0 009 10.125a2.71 2.71 0 001.687-.562l6.187-4.641z","fill":"#bac1cc"}})])
          )
        }
      }
    